import { Component, Vue } from 'vue-property-decorator';

@Component<Divider>({})
export default class Divider extends Vue {
  //
}
